'use strict';

var wishlistHelper = require('../wishlist/wishlistHelper');

/**
 * Mark elements as being in wishlist.
 * @param {Array} elements - List of wishlist button containers.
 */
function markElementAsInWishlist(elements) {
    if (!elements) {
        return;
    }

    for (var i = 0; i < elements.length; i += 1) {
        var element = elements[i];
        var inactive = element.querySelector('.wishlist-inactive');
        var active = element.querySelector('.wishlist-active');

        if (inactive) {
            inactive.classList.remove('active');
        }

        if (active) {
            active.classList.add('active');
        }
    }
}

/**
 * Callback for wishlist ready event.
 * @param {Array} items - List containing product ID's in wishlist.
 */
function handleWishlistReady(items) {
    var elements = Array.from(document.querySelectorAll('.wishlistStaticToggle'));

    var idsOnPage = elements.reduce(function (result, element) {
        var id = element.getAttribute('data-wishlist-id') || null;

        // Remove the class used in the DOM lookup to prevent double work.
        element.classList.remove('wishlistStaticToggle');

        if (!id) {
            return result;
        }

        // eslint-disable-next-line no-param-reassign
        result[id] = result[id] || [];
        result[id].push(element);

        return result;
    }, {});

    for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        var mathchingElements = idsOnPage[item] || null;

        if (mathchingElements) {
            markElementAsInWishlist(mathchingElements);
        }
    }
}

module.exports = {
    init: function () {
        wishlistHelper.init();
        wishlistHelper.callOnReady(handleWishlistReady);
    },
    update: function () {
        wishlistHelper.callOnReady(handleWishlistReady);
    }
};
